import React from 'react'
import { Button } from '../buttons'

export default ({ technicianWorkSummary, ...props }) => (
  <Button {...props} className="button small problem" />
)



// WEBPACK FOOTER //
// ./src/components/technician-work-summaries/unsatisfactory-areas-button.js